module.exports = __webpack_public_path__ + "img/barrowhall-h-474x356.21acc9d0.jpg";